import { Action, ActionTypes, AuthState } from './types';

const reducer = (state: AuthState, action: Action): AuthState => {
  switch (action.type) {
    case ActionTypes.INITIALIZE:
      return {
        ...state,
        isInitialized: true,
        isAuthenticated: action.payload
      };

    default: {
      return { ...state };
    }
  }
};

export default reducer;
